import { createApp } from 'vue'
import('@/assets/styles/Global.css');
import router from './app/router'
import App from "@/App.vue"; 

createApp(App)
    .use(router)
    .mount('#app')